import {mapActions, mapGetters, mapMutations} from 'vuex';
import {camelCase} from 'lodash';

import Item from '@/components/main-item/index.vue'
import BtnLoadMore from '@/components/atoms/buttons/load-more/index.vue'
import HeadFilter from '@/components/features/head-filter/index.vue'
import {seo} from '@/mixins/seo'

export default {
    name: 'education-list',
    mixins: [seo],
    components: {
        Item,
        BtnLoadMore,
        HeadFilter
    },
    created() {
        if (!this.categories.length) {
            this.seo.title = this.$t(camelCase(this.$route.name))
            this.fetchCategories()
        }

        if (!this.isListLoading && !this.list.length) {
            this.fetchData({isResetList: true, educationType: this.$route.name})
        }
    },
    watch: {
        '$route.name'() {
            this.seo.title = this.$t(camelCase(this.$route.name))
            this.$emit('updateHead')
        }
    },
    beforeRouteLeave(to, from, next) {
        if (!to.name.includes(this.$route.name)) {
            this.changeCategory()
            if (to.name === 'webinars' ||
                to.name === 'master-classes' ||
                to.name === 'bonuses' ||
                to.name === 'qa-sessions') {
                this.fetchData({isResetList: true, educationType: to.name})
            }
        }
        next();
    },
    computed: {
        ...mapGetters({
            list: 'education/list',
            listLength: 'education/listLength',
            isListLoading: 'education/isListLoading',

            categories: 'education/categories',
            isLoadingCategories: 'education/isLoadingCategories',
        })
    },
    methods: {
        ...mapActions({
            fetchData: 'education/GET_LIST',
            fetchCategories: 'education/GET_CATEGORIES',
        }),
        ...mapMutations({
            changeCategory: 'education/CHANGE_CATEGORY',
            setCategories: 'education/SET_CATEGORIES',
        }),
        loadMore() {
            this.fetchData({isResetList: false, educationType: this.$route.name})
        },
        formattedTitle(title) {
            return camelCase(title)
        }
    },
}
